var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinearError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 130,
    viewBox: "0 0 131 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 65C5.5 31.8629 32.3629 5 65.5 5C98.6371 5 125.5 31.8629 125.5 65C125.5 98.1371 98.6371 125 65.5 125C32.3629 125 5.5 98.1371 5.5 65Z",
    fill: "#FEE4E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 65C5.5 31.8629 32.3629 5 65.5 5C98.6371 5 125.5 31.8629 125.5 65C125.5 98.1371 98.6371 125 65.5 125C32.3629 125 5.5 98.1371 5.5 65Z",
    stroke: "#FEF3F2",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 56.9999V67.6666M66 78.3332H66.0267M62.3075 43.3778L40.3745 81.2621C39.1579 83.3634 38.5497 84.4141 38.6396 85.2764C38.718 86.0285 39.112 86.712 39.7237 87.1567C40.4249 87.6666 41.6389 87.6666 44.067 87.6666H87.933C90.3611 87.6666 91.5751 87.6666 92.2763 87.1567C92.888 86.712 93.282 86.0285 93.3604 85.2764C93.4503 84.4141 92.8421 83.3634 91.6255 81.2621L69.6925 43.3778C68.4803 41.284 67.8742 40.2372 67.0835 39.8855C66.3937 39.5788 65.6063 39.5788 64.9165 39.8855C64.1258 40.2372 63.5197 41.284 62.3075 43.3778Z",
    stroke: "#912018",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinearError);
export default __webpack_public_path__ + "static/media/linearError.087bb0729d76dcc051205c577abc2ced.svg";
export { ForwardRef as ReactComponent };